/**
 * Plain-language text for the event write refusals a user can actually hit
 * (tracker 2026-11-04: plain managers saw "Failed to update date/time" and
 * "Failed to duplicate event" when the server refused them). Permissions are
 * unchanged; this only says WHY. Returns null for anything else so callers
 * keep their own fallback.
 *
 * Sources: _events_manager_edit_guard (MANAGER_EDIT_*, migs 197/221/1120) and
 * set_event_dates (date-model events), duplicate_event ("permission denied: cannot duplicate event", MSR_CANNOT_CREATE_EVENTS).
 */
export function eventRefusalMessage(err: unknown): string | null {
  const text = (v: unknown): string => {
    const m =
      typeof v === "string" ? v : (v as { message?: unknown } | null)?.message;
    return typeof m === "string" ? m : "";
  };
  // updateEvent may wrap the database error (describeDateModelError) and keep it as `cause`.
  const msg = `${text(err)} ${text((err as { cause?: unknown } | null)?.cause)}`;
  if (
    /MANAGER_EDIT_NO_DATES/.test(msg) ||
    /set_event_dates: you do not have permission/.test(msg)
  ) {
    return "Only the event's owner or an admin can change the date on this event.";
  }
  if (/MANAGER_EDIT_NO_CANCEL/.test(msg)) {
    return "Only the event's owner or an admin can cancel this event.";
  }
  if (/MANAGER_EDIT_NO_DELETE/.test(msg)) {
    return "Only the event's owner or an admin can delete this event.";
  }
  if (/permission denied: cannot duplicate event/i.test(msg)) {
    return "Only the event's owner, an admin, or someone the event is shared with for editing can duplicate this event.";
  }
  if (
    /Regional and Territory Managers do not change an event's dates/.test(msg)
  ) {
    return "Regional and Territory Managers can't change an event's dates. Ask the event's owner or an admin.";
  }
  if (/MSR_CANNOT_CREATE_EVENTS/.test(msg)) {
    return "MSRs cannot duplicate or create events.";
  }
  return null;
}
